// Debounce delay (ms) for margin-rule input updates in Conditions.jsx.
//
// This lives in its own module so tests can mock it to 0 for deterministic,
// mode-independent behavior. It replaces the previous `import.meta.env.MODE ===
// 'test'` branch inside Conditions.debounceRuleUpdates, which disabled the
// debounce only in `test` mode — that made tests pass under `vitest` (MODE=test)
// but fail under CI's `--mode staging` run, where the 500ms debounce was live.
export const RULE_UPDATE_DEBOUNCE_MS = 500;
